"use client";

import { FC } from "react";

import Spacer from "apps/website/components/layout/Spacer/Spacer";
import TextTitle from "apps/website/components/base/Text/TextTitle/TextTitle";

interface TitleSectionProps {
  title: string | undefined;
  hideProgressSteps: boolean | undefined;
  getTitle: () => string;
}

export const TitleSection: FC<TitleSectionProps> = ({
  title,
  hideProgressSteps = false,
  getTitle,
}) => {
  if (!title) {
    return null;
  }

  return (
    <div className="bg-white">
      <Spacer size={hideProgressSteps ? "md-lg" : "2xl"} />
      <TextTitle size={3} align="center" className="px-4">
        { getTitle() }
      </TextTitle>
      <Spacer size={hideProgressSteps ? "md-lg" : "md"} />
    </div>
  );
};
